module.exports = __webpack_public_path__ + "img/report-1.de124bf8.png";